import { styled } from "@mui/material/styles";
import BSInput from "../../../common/js/components/BSInput";

const StyledSuiteNumber = styled(BSInput)(() => ({
    width: "calc(50% - 0.5vw)",
    "@media (max-width: 1280px)": {
        width: "100%",
    },
}));

const StyledOtherContainer = styled("div")(() => ({
    display: "flex",
    alignItems: "flex-start",
    gap: "1vw",
}));
const OtherForm = (props) => {
    const handleAttributeUpdate = (event) => {
        props.onChange(event.target.id, event.target.value);
    };

    const { data, disableInputs, errors, handleBlurValidate } = props;

    return (
        <div>
            <StyledOtherContainer>
                <BSInput
                    id="sfAvail"
                    label="OTHER SF AVAILABLE"
                    placeholder="Enter SF"
                    errorText="ex. 98101"
                    error={errors.sfAvail}
                    value={data.sfAvail}
                    onChange={handleAttributeUpdate}
                    extraFormControlStyles={{ flex: "1 1 0" }}
                    disabled={disableInputs}
                    integer
                    onBlurValidate={(id, value) => handleBlurValidate("Other", id, value)}
                />
                <BSInput
                    id="largestContigSf"
                    label="OTHER CONTIGUOUS SF AVAILABLE"
                    placeholder="Enter SF"
                    errorText="ex. 98101"
                    error={errors.largestContigSf}
                    value={data.largestContigSf}
                    onChange={handleAttributeUpdate}
                    extraFormControlStyles={{ flex: "1 1 0" }}
                    disabled={disableInputs}
                    integer
                    onBlurValidate={(id, value) => handleBlurValidate("Other", id, value)}
                />
            </StyledOtherContainer>
            <StyledOtherContainer>
                <StyledSuiteNumber
                    id="suite"
                    label="OTHER SUITE NUMBER"
                    placeholder="Enter number"
                    error={errors.suite}
                    value={data.suite}
                    onChange={handleAttributeUpdate}
                    disabled={disableInputs}
                />
            </StyledOtherContainer>
        </div>
    );
};

export default OtherForm;
